module.exports = __webpack_public_path__ + "static/media/fire-zone.42e13657.svg";